import type { BucketCount, FocusBucket } from "@ceo-cmd/shared";
import { cn } from "@/cn";
import { BUCKET_LABELS } from "./labels";

const ORDER: FocusBucket[] = [
  "act_now",
  "decision_required",
  "waiting",
  "at_risk",
  "monitoring",
  "all_active",
];

export function FocusBucketSelector({
  buckets,
  active,
  onChange,
}: {
  buckets: BucketCount[];
  active: FocusBucket;
  onChange: (bucket: FocusBucket) => void;
  /** @deprecated Always rendered as a compact horizontal selector. */
  orientation?: "vertical" | "horizontal";
}) {
  const countMap = Object.fromEntries(buckets.map((b) => [b.bucket, b.count]));

  return (
    <div className="flex gap-1.5 overflow-x-auto pb-0.5">
      {ORDER.map((bucket) => {
        const selected = active === bucket;
        return (
          <button
            key={bucket}
            type="button"
            onClick={() => onChange(bucket)}
            className={cn(
              "inline-flex shrink-0 items-center gap-1.5 rounded-md px-2.5 py-1.5 text-xs font-medium transition",
              selected
                ? "bg-brand text-brand-foreground"
                : "border border-border bg-card text-foreground hover:bg-surface-hover",
            )}
          >
            <span>{BUCKET_LABELS[bucket]}</span>
            <span
              className={cn(
                "rounded-full px-1.5 py-0.5 text-[10px] tabular-nums",
                selected ? "bg-white/20" : "bg-muted/40 text-muted-foreground",
              )}
            >
              {countMap[bucket] ?? 0}
            </span>
          </button>
        );
      })}
    </div>
  );
}
